import { SignRequest } from '@bitte-ai/types';
import { Hex, hashMessage, hashTypedData, keccak256 } from 'viem';
import { isValidTypedData } from './typed-data';

export function signRequestId(request: SignRequest): Hex {
  switch (request.method) {
    case 'eth_sendTransaction': {
      // Warning: This is not a Transaction Hash!
      // Transaction hashes can only be computed after all the fields are filled in (e.g. gas, nonce, etc.)
      // For an Identifier, we will use all transactions in params
      const txData = request.params.map((tx) => ({
        ...tx,
        chainId: request.chainId,
      }));
      return keccak256(new TextEncoder().encode(JSON.stringify(txData)));
    }
    // All other cases actually return the hashToSign.
    case 'personal_sign':
      return hashMessage(request.params[0]);

    case 'eth_sign':
      return keccak256(request.params[1]);

    case 'eth_signTypedData':
    case 'eth_signTypedData_v4': {
      try {
        const typedDataString = request.params[1];
        if (typeof typedDataString !== 'string') {
          throw new Error('Expected JSON string for typed data parameter');
        }

        const parsedData = JSON.parse(typedDataString);

        if (!isValidTypedData(parsedData)) {
          throw new Error(
            'Invalid typed data structure: data does not conform to EIP-712 specification',
          );
        }

        return hashTypedData({
          domain: parsedData.domain,
          types: parsedData.types,
          primaryType: parsedData.primaryType,
          message: parsedData.message,
        });
      } catch (error) {
        console.error('Error parsing typed data in signRequestId:', error);
        throw new Error(
          `Failed to parse typed data: ${error instanceof Error ? error.message : 'Unknown error'}`,
        );
      }
    }

    default:
      throw new Error(`Unsupported method: ${(request as any).method}`);
  }
}
